import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const ClockRotateIcon = (props) => <FontAwesomeIcon icon={["fas", "history"]} flip="horizontal" {...props}/>


export default ClockRotateIcon;